export default {
    PADRAO: 1,
    EM_BRANCO: 2,
}